import front from './front'
import back from './back'

const routes = [...back, ...front]

export default routes
